import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000/api/v1",
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const getCategories   = ()       => api.get("/api/v1/support/categories/");
export const getMyTickets    = ()       => api.get("/api/v1/user/tickets/");
export const getTicket       = (id)     => api.get(`/api/v1/user/tickets/${id}/`);
export const createTicket    = (data)   => api.post("/api/v1/user/tickets/", data);
export const replyTicket     = (id, d)  => api.post(`/api/v1/user/tickets/${id}/reply/`, d);
export const cancelTicket    = (id)     => api.delete(`/api/v1/user/tickets/${id}/`);

//

export const getUserTicket       = (id)     => api.get(`/api/v1/user/tickets/${id}/`);
export const createUserTicket    = (data)   => api.post("/api/v1/user/tickets/", data);
export const replyUserTicket     = (id, d)  => api.post(`/api/v1/user/tickets/${id}/reply/`, d);
export const cancelUserTicket    = (id)     => api.delete(`/api/v1/user/tickets/${id}/`);

/**
 * Formulaires publics Contact (kind:"contact") et Partenariat (kind:"partnership").
 * - connecté  → le backend crée un ticket (push + cloche + réponse dans « Mes tickets »)
 * - visiteur  → message + accusé et réponse par email
 * Un jeton expiré ferait refuser la requête (401) même sur une route publique :
 * on réessaie alors sans Authorization, en visiteur.
 */
export const sendContactMessage = async (data) => {
  const payload = { ...data, lang: data.lang || localStorage.getItem("language") || "fr" };
  try {
    return await api.post("/api/v1/contact/", payload);
  } catch (err) {
    if (err?.response?.status === 401) {
      return api.post("/api/v1/contact/", payload, { headers: { Authorization: undefined } });
    }
    throw err;
  }
};

export default api;